export default __webpack_public_path__ + "static/media/t_facebook.3c623fbf.png";